module.exports = __webpack_public_path__ + "static/woaw-screenshot-db6b227346a0a57d6e2cde4895b4eb80.jpg";